import {
  AgeRange,
  InstantEventType,
  PricingTier,
  StylingPreferenceRequest,
} from '@/shared/types/generated';

export const STYLIST_MATCH_EXPIRATION_SECONDS = 60;

export const DURATION_OPTIONS = [
  { label: '60 minutes', value: InstantEventType.SixtyMinutes },
  { label: '45 minutes', value: InstantEventType.FortyFiveMinutes },
  { label: '30 minutes', value: InstantEventType.ThirtyMinutes },
  { label: '15 minutes', value: InstantEventType.FifteenMinutes },
];

export const PRICING_TIER_OPTIONS = [
  { label: 'Foundation', value: PricingTier.Tier1 },
  { label: 'Elevated', value: PricingTier.Tier2 },
  { label: 'Premiere', value: PricingTier.Tier3 },
  { label: 'Elite', value: PricingTier.Tier4 },
];

export const AGE_OPTIONS = [
  { label: 'No Preference', value: AgeRange.NoPreference },
  { label: '18-24 years old', value: AgeRange.Age_18_24 },
  { label: '25-34 years old', value: AgeRange.Age_25_34 },
  { label: '35-44 years old', value: AgeRange.Age_35_44 },
  { label: '45-54 years old', value: AgeRange.Age_45_54 },
  { label: '55-64 years old', value: AgeRange.Age_55_64 },
  { label: '65+ years old', value: AgeRange.Age_65Plus },
];

export const STYLE_OPTIONS = [
  { label: 'No Preference', value: StylingPreferenceRequest.NoPreference },
  { label: 'Bohemian', value: StylingPreferenceRequest.Bohemian },
  { label: 'Feminine', value: StylingPreferenceRequest.Feminine },
  { label: 'Grunge', value: StylingPreferenceRequest.Grunge },
  { label: 'Maximalist', value: StylingPreferenceRequest.Maximalist },
  { label: 'Minimalist', value: StylingPreferenceRequest.Minimalist },
  { label: 'Classic', value: StylingPreferenceRequest.Classic },
  { label: 'Trendy', value: StylingPreferenceRequest.Trendy },
  { label: 'Streetwear', value: StylingPreferenceRequest.Streetwear },
  { label: 'Athleisure', value: StylingPreferenceRequest.Athleisure },
  { label: 'Vintage', value: StylingPreferenceRequest.Vintage },
];

export const MatchResultCode = {
  NO_ACTIVE_STYLISTS: 'NO_ACTIVE_STYLISTS',
  NO_STYLISTS_MATCH_CRITERIA: 'NO_STYLISTS_MATCH_CRITERIA',
  SUCCESS: 'SUCCESS',
} as const;

export type MatchResultCodeType =
  (typeof MatchResultCode)[keyof typeof MatchResultCode];
